<template>
  <v-container class="register pa-0" fluid>
    <HkiaraceBannerFrame :src="require('@/assets/canteen_register.jpg')"
                         :label="$t('check_status.title')"
                         is-snap-content>
      <div class="form-div">
        <v-window v-model="step"
                  touchless>
          <v-window-item>
            <v-container>
              <v-row>
                <v-col class="form-title title-font text-center">
                  {{ $t('check_status.title') }}
                </v-col>
              </v-row>
              <v-form ref="stepTwoForm">
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.surname')"
                                  placeholder="CHAN"
                                  persistent-placeholder
                                  v-model="surname"
                                  :rules="nameRules"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.given_name')"
                                  placeholder="TAI MAN"
                                  persistent-placeholder
                                  v-model="givenName"
                                  :rules="nameRules"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field outlined
                                  :label="$t('register.octopus_no')"
                                  placeholder="123456789"
                                  persistent-placeholder
                                  v-model="octopusNo"
                                  v-mask="'########?#?#'"
                                  :rules="octopusNoRules"
                                  hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <v-btn dark
                           color="primary"
                           rounded
                           x-large
                           @click="$refs.stepTwoForm.validate() && checkSasv()">
                      {{ $t('next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-window-item>
          <v-window-item>
            <v-container v-if="submittedSasv">
              <SasvStatus :sasv="submittedSasv"></SasvStatus>

              <v-row v-if="submittedSasv.rejected_at"
                     class="text-center mt-4">
                <v-col>
                  <v-btn color="primary"
                         @click="$router.push({name: 'Register'})">{{ $t('resubmit') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-window-item>
        </v-window>
      </div>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "@/components/HkiaraceBannerFrame";
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import SasvStatus from "@/components/SasvStatus";

export default {
  name: 'CheckStatus',
  components: {SasvStatus, HkiaraceBannerFrame},
  setup(props, {root}) {
    const step = ref(0);

    const surname = ref(null);
    const givenName = ref(null);
    const nameRules = ref([
      value => !!value || root.$t('register.enter_required_field'),
      value => !!/^[a-zA-Z ]*$/g.test(value) || root.$t('register.only_input_english_characters'),
    ]);
    const octopusNo = ref(null);
    const octopusNoRules = ref([
      value => !!value || root.$t('register.enter_required_field'),
      value => !!/^[0-9]{8,10}$/g.test(value) || root.$t('register.incorrect_octopus_no'),
    ]);
    const checkSasv = async function () {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'sasv/status/',
          params: {
            surname: surname.value,
            given_name: givenName.value,
            octopus_no: octopusNo.value,
          },
        });

        if (response.body.sasv) {
          let sasv = response.body.sasv;
          if (sasv.status !== 'NOT_SUBMITTED') { // Submitted
            submittedSasv.value = sasv;
            step.value = 1;
            return
          }
        }

        root.$showAlertMessage(root.$t('error_messages.octopus_not_registered'), () => {
          root.$router.replace({name: 'Register'});
        });
      } catch (response) {
        root.$tryHandleError(response);
      }
    };

    const submittedSasv = ref(null);

    return {
      step,

      surname,
      givenName,
      nameRules,
      octopusNo,
      octopusNoRules,
      checkSasv,

      submittedSasv,
    }
  },
}
</script>
